import React, { FunctionComponent, SyntheticEvent } from 'react';
import { pathOr } from 'ramda';

type Props = {
  record?: Record<string, any>;
  source?: Array<number | string>;
  options?: Record<string, unknown>;
  onClickHandler?: (selectedCampaign: string) => void;
  selectedCampaign?: string;
  type: 'checkbox' | 'radio';
};

const Checkbox: FunctionComponent<Props> = ({
  onClickHandler,
  record,
  selectedCampaign,
  type,
}) => {
  const uuid = pathOr<string>('', ['campaign', 'uuid'], record);
  const onChangeHandler = (_: SyntheticEvent<HTMLInputElement>) => {
    onClickHandler && onClickHandler(uuid);
  };

  return (
    <input
      type={type}
      checked={selectedCampaign === uuid}
      onChange={onChangeHandler}
    />
  );
};

export default Checkbox;
